<template>
    <div>
        <slot name="header" v-if="list.length > 0"></slot>
        <div :class="wrapClass">
            <slot v-bind="list">
                <slot v-for="item in list" name="item" v-bind="item"></slot>
                <slot name="extraItem"></slot>
            </slot>
        </div>
        <slot name="loader" v-bind="{loading}">
            <div class="text-center" v-if="!isShowMore">
                <div v-if="loading" class="spinner-border spinner-border-sm text-primary" role="status">
                    <span class="sr-only"></span>
                </div>
            </div>
        </slot>

        <div>
            <slot name="noContent" v-bind="list">
                <no-content-placeholder
                    v-if="!list.length && !loading"
                    :icon="emptyIcon"
                    :title="emptyTitle"
                    :text="emptyText"
                    :help-slug="emptyHelpSlug"
                    :action="emptyAction"
                    :actionText="emptyActionText"
                    v-on="$listeners"/>
            </slot>
        </div>

        <slot name="pagination">
            <div class="row mt-4">
                <div class="col-12 text-center" v-if="!isShowMore">
                    <div class=" text-center d-flex flex-column align-items-center align-self-center">
                        <pagination
                            class="align-self-center"
                            v-if="total > limit"
                            :records="total"
                            v-model="pageNum"
                            :per-page="limit"
                            :options="VUE_PAGINATION_OPTIONS"
                            @paginate="onPageChange"/>
                    </div>
                </div>
                <div class="col-12" v-else>
                    <div class="text-center">
                        <button class="btn btn-open btn-secondary " @click="loadMore" v-if="pageNum * limit < total">
                            <div v-if="loading" class="spinner-border spinner-border-sm text-primary" role="status">
                                <span class="sr-only"></span>
                            </div>
                            <span v-else>{{ trans('general.defaults.show_more') }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </slot>
    </div>
</template>

<script>
import Pagination from "vue-pagination-2";
import axios from "axios";
import {VUE_PAGINATION_OPTIONS} from "../../services/Defaults";
import NoContentPlaceholder from "../organisms/NoContentPlaceholder.vue";
import WaitingIndicatorIcon from "../atoms/WaitingIndicatorIcon.vue";
import Button from "../atoms/BasicButton.vue";
import {eventBus} from "../../services/EventBus";

export default {
    name: "ListProvider",
    computed: {
        VUE_PAGINATION_OPTIONS() {
            return VUE_PAGINATION_OPTIONS
        }
    },
    props: {
        isShowMore: {
            type: Boolean,
            default() {
                return true
            }
        },
        url: {
            type: String,
            required: true
        },
        page: {
            default() {
                return 1
            }
        },
        limit: {
            default() {
                return 20
            }
        },
        params: {
            type: Object,
            default() {
                return {}
            }
        },
        wrapClass: {
            type: String,
            default() {
                return 'row'
            }
        },
        sort: {
            type: Object,
            default() {
                return {
                    order_by: null,
                    sorted_by: null,
                }
            }
        },
        emptyIcon: {
            type: String,
            required: false
        },
        emptyTitle: {
            type: String,
            required: false
        },
        emptyText: {
            type: String,
            required: false
        },
        emptyHelpSlug: {
            type: String,
            required: false
        },
        emptyAction: {
            type: String|Function,
            required: false
        },
        emptyActionText: {
            type: String,
            required: false
        },
    },
    components: {Button, WaitingIndicatorIcon, NoContentPlaceholder, Pagination},
    data() {
        return {
            pageNum: this.page,
            total: null,
            loading: false,
            list: [],
        }
    },
    watch: {
        sort: {
            handler: function (val, oldVal) {
                if (val.order_by !== oldVal.order_by || val.sorted_by !== oldVal.sorted_by) {
                    this.reload();
                }
            },
            deep: true
        },
        total: function (val) {
            this.$emit('total-changed', val)
        }
    },
    methods: {
        onPageChange(page) {
            this.pageNum = page;
            this.loadData();
            this.$emit('page-changed', page)
        },
        loadData() {
            this.loading = true;
            axios.get(this.url, {
                params: {
                    ...this.params,
                    page: this.pageNum,
                    limit: this.limit,
                    ...this.sort
                }
            }).then(response => {
                this.list = this.isShowMore ? [...this.list, ...response.data.data.data] : response.data.data.data;
                this.total = response.data.data.total;
                this.loading = false;
                this.$emit('data-loaded', response.data);
                eventBus.$emit('triggerCreateBtn', this.list.length > 0);
            }).catch(error => {
                this.loading = false;
                this.$emit('data-load-error', error)
            });
        },
        loadMore() {
            this.pageNum++;
            this.loadData();
        },
        reload(samePage = false) {
            if (!samePage) {
                this.list = [];
                this.pageNum = 1;
            }
            this.loadData();
        },
    },
    mounted() {
        this.loadData();
    }
}
</script>
